/* CIY product page — "already in your cart" state.

   Two things switch over once the product being viewed is in the cart:

     1. The sticky bar stops offering Add to cart and instead reports the cart:
        thumbnail, "N items", "You save ₹X", and a View Cart button.
     2. The add-to-cart button in the details column is replaced by a stepper
        that edits that line's quantity in the cart directly.

   Cart facts come from sections/ciy-cart-summary.liquid rather than /cart.js,
   because the saving needs variant.compare_at_price, which the AJAX cart API
   does not return. That section is rendered on page load and re-fetched through
   the Section Rendering API after every mutation. */
(function () {
  var state = null;      // the [data-ciy-cart-state] element
  var busy = false;

  function num(el, attr) { return parseInt(el.getAttribute(attr), 10) || 0; }
  function pad2(n) { return n < 10 ? '0' + n : String(n); }

  /* ------------------------------------------------------------------ read */

  function readState() { return document.querySelector('[data-ciy-cart-state]'); }

  function snapshot() {
    if (!state) return null;
    return {
      count: num(state, 'data-count'),
      savings: num(state, 'data-savings'),
      savingsMoney: state.getAttribute('data-savings-money') || '',
      thumbs: (state.getAttribute('data-thumbs') || '').split('|').filter(Boolean),
      qty: num(state, 'data-line-qty'),
      key: state.getAttribute('data-line-key') || '',
      cartUrl: state.getAttribute('data-cart-url') || '/cart'
    };
  }

  /* Re-render the hidden section and copy its attributes over, so every later
     read sees fresh numbers. */
  function refresh() {
    if (!state) return Promise.resolve();
    var url = state.getAttribute('data-url');
    if (!url) return Promise.resolve();
    var bust = url + (url.indexOf('?') > -1 ? '&' : '?') + 'ciy=' + Date.now();

    return fetch(bust, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(new Error('HTTP ' + r.status)); })
      .then(function (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-ciy-cart-state]');
        if (!fresh) return;
        ['data-count', 'data-savings', 'data-savings-money', 'data-thumbs', 'data-line-qty', 'data-line-key']
          .forEach(function (a) { state.setAttribute(a, fresh.getAttribute(a) || ''); });
        render();
      })
      .catch(function () { /* keep whatever we last knew */ });
  }

  /* ----------------------------------------------------------------- build */

  function stickyAdded(bar, s) {
    var el = bar.querySelector('[data-ciy-sticky-added]');
    if (!el) {
      el = document.createElement('div');
      el.className = 'ciy-sticky-added';
      el.setAttribute('data-ciy-sticky-added', '');
      el.innerHTML =
        '<span class="ciy-sticky-added__thumbs" data-ciy-thumbs></span>' +
        '<span class="ciy-sticky-added__text">' +
          '<strong data-ciy-count></strong>' +
          '<span class="ciy-sticky-added__save" data-ciy-save></span>' +
        '</span>' +
        '<a class="ciy-sticky-added__cta button" data-ciy-cart-link>View Cart</a>';
      bar.appendChild(el);
    }

    /* One thumbnail per cart line, as drawn. Rebuilt rather than mutated so a
       removed line does not leave its image behind. */
    var thumbs = el.querySelector('[data-ciy-thumbs]');
    if (thumbs.getAttribute('data-src') !== s.thumbs.join('|')) {
      thumbs.setAttribute('data-src', s.thumbs.join('|'));
      thumbs.innerHTML = s.thumbs.map(function (src) {
        return '<img alt="" width="44" height="44" src="' + src + '">';
      }).join('');
    }
    el.querySelector('[data-ciy-count]').textContent = s.count + (s.count === 1 ? ' item' : ' items');
    var save = el.querySelector('[data-ciy-save]');
    if (s.savings > 0) { save.textContent = 'You save ' + s.savingsMoney; save.hidden = false; }
    else { save.hidden = true; }
    el.querySelector('[data-ciy-cart-link]').setAttribute('href', s.cartUrl);
  }

  function mainStepper(form, s) {
    var el = form.querySelector('[data-ciy-cart-qty]');
    if (!el) {
      el = document.createElement('div');
      el.className = 'ciy-cart-qty';
      el.setAttribute('data-ciy-cart-qty', '');
      el.innerHTML =
        '<button type="button" class="ciy-cart-qty__btn ciy-cart-qty__btn--minus" data-ciy-step="-1" aria-label="Decrease quantity in cart">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M5 12h14"/></svg>' +
        '</button>' +
        '<span class="ciy-cart-qty__value" data-ciy-qty-value aria-live="polite"></span>' +
        '<button type="button" class="ciy-cart-qty__btn ciy-cart-qty__btn--plus" data-ciy-step="1" aria-label="Increase quantity in cart">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>' +
        '</button>';
      form.appendChild(el);
      el.addEventListener('click', onStep);
    }
    el.querySelector('[data-ciy-qty-value]').textContent = pad2(s.qty);
    el.classList.toggle('is-busy', busy);
  }

  /* ---------------------------------------------------------------- render */

  function render() {
    var s = snapshot();
    if (!s) return;
    var inCart = s.qty > 0 && s.key !== '';

    document.querySelectorAll('sticky-add-to-cart').forEach(function (host) {
      var bar = host.querySelector('.sticky-add-to-cart__bar');
      if (!bar) return;
      stickyAdded(bar, s);
      host.setAttribute('data-ciy-in-cart', inCart ? 'true' : 'false');
    });

    document.querySelectorAll('.product-form-buttons').forEach(function (form) {
      mainStepper(form, s);
      form.setAttribute('data-ciy-in-cart', inCart ? 'true' : 'false');
    });
  }

  /* ---------------------------------------------------------------- mutate */

  function onStep(e) {
    var btn = e.target.closest('[data-ciy-step]');
    if (!btn || busy) return;
    var s = snapshot();
    if (!s || !s.key) return;

    var next = s.qty + parseInt(btn.getAttribute('data-ciy-step'), 10);
    if (next < 0) return;

    busy = true;
    render();

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: s.key, quantity: next })
    })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(new Error('HTTP ' + r.status)); })
      .then(function () {
        /* Let the theme's own cart UI (drawer, bubble) catch up too. */
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(function () {})
      .then(function () { busy = false; return refresh(); });
  }

  /* The theme adds to cart over AJAX and its event names vary by version, so
     rather than guess at them — or at how long the request takes — poll the
     cart until the count actually moves, then re-render. Fixed timers missed
     the swap whenever the add took longer than the last one fired. */
  function pollUntilCartChanges(was) {
    var tries = 0;
    (function attempt() {
      tries += 1;
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (cart.item_count !== was) return refresh();
          if (tries < 20) setTimeout(attempt, 300);   // give up after ~6s
        })
        .catch(function () { if (tries < 20) setTimeout(attempt, 300); });
    })();
  }

  function watchAdds() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.add-to-cart-button, .sticky-add-to-cart__button, [data-ciy-fbt-add]');
      if (!btn) return;
      var s = snapshot();
      pollUntilCartChanges(s ? s.count : -1);
    }, true);

    ['cart:update', 'cart:refresh', 'cart:change', 'variant:update'].forEach(function (evt) {
      document.addEventListener(evt, function () { setTimeout(refresh, 120); });
    });
  }

  /* Shopify's theme-preview bar is an iframe pinned over the bottom of the
     viewport, and it takes the clicks in that strip. Now that the sticky bar
     sits flush at bottom:0 the whole bar — View Cart included — lands inside
     that strip and stops responding while a preview session is active. Lift the
     bar clear of it. Customers have no preview bar, so the offset is 0 and the
     bar stays flush as drawn. */
  function clearPreviewBar() {
    var bars = document.querySelectorAll('.sticky-add-to-cart__bar');
    if (!bars.length) return;

    var pbar = document.getElementById('PBarNextFrame') ||
               document.querySelector('iframe[src*="preview-bar"]');
    var lift = 0;

    if (pbar) {
      /* The iframe spans the whole viewport but only accepts clicks where it
         actually paints, so probe upward from the bottom to find that edge
         rather than hard-coding a height that changes with breakpoint. */
      var x = Math.round(document.documentElement.clientWidth / 2);
      for (var y = window.innerHeight - 1; y > window.innerHeight - 220; y--) {
        var el = document.elementFromPoint(x, y);
        if (el && el.tagName === 'IFRAME') { lift = window.innerHeight - y; }
        else if (lift) { break; }
      }
      if (!lift) lift = 68;
    }

    bars.forEach(function (b) { b.style.setProperty('--ciy-sticky-lift', lift + 'px'); });
  }

  function boot() {
    state = readState();
    if (!state) return;
    render();
    watchAdds();
    clearPreviewBar();
    /* The preview bar is injected after load, so measure again once it is in. */
    setTimeout(clearPreviewBar, 1500);
    window.addEventListener('resize', clearPreviewBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
